import classNames from "classnames";
import PropTypes from "prop-types";
import { MdCheck } from "react-icons/md";

const clampIndex = (value, max) => {
  if (max < 0) return 0;
  if (value < 0) return 0;
  if (value > max) return max;
  return value;
};

const ProcessStepper = ({
  steps,
  current = 0,
  className,
  "aria-label": ariaLabel,
}) => {
  if (!steps?.length) return null;

  const lastIndex = steps.length - 1;
  const activeIndex = clampIndex(current, lastIndex);

  return (
    <nav
      className={classNames("process-stepper", className)}
      aria-label={ariaLabel}
    >
      <ol className="process-stepper__inner">
        {steps.map((step, index) => {
          const state =
            index < activeIndex
              ? "finish"
              : index === activeIndex
                ? "process"
                : "wait";

          const lineBeforeComplete = index > 0 && activeIndex > index - 1;
          const lineAfterComplete = index < lastIndex && activeIndex > index;

          return (
            <li
              key={index}
              className={classNames(
                "process-stepper__item",
                `process-stepper__item--${state}`,
              )}
              aria-current={state === "process" ? "step" : undefined}
            >
              <div className="process-stepper__row-top">
                {index === 0 ? (
                  <span className="process-stepper__spacer" aria-hidden />
                ) : (
                  <span
                    className={classNames("process-stepper__line", {
                      "process-stepper__line--complete": lineBeforeComplete,
                    })}
                    aria-hidden
                  />
                )}
                <span className="process-stepper__dot-wrapper">
                  <span className="process-stepper__dot" aria-hidden>
                    {state === "finish" ? (
                      <span className="process-stepper__check">
                        <MdCheck size={20} />
                      </span>
                    ) : (
                      index + 1
                    )}
                  </span>
                </span>
                {index === lastIndex ? (
                  <span className="process-stepper__spacer" aria-hidden />
                ) : (
                  <span
                    className={classNames("process-stepper__line", {
                      "process-stepper__line--complete": lineAfterComplete,
                    })}
                    aria-hidden
                  />
                )}
              </div>
              <span
                className="process-stepper__label"
                dangerouslySetInnerHTML={{ __html: step.title }}
              />
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

ProcessStepper.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.node.isRequired,
    }),
  ).isRequired,
  current: PropTypes.number,
  className: PropTypes.string,
  "aria-label": PropTypes.string,
};

export default ProcessStepper;
